import React, { useState, useEffect } from 'react';
import { getAllJobOpenings } from "api/apiHelper";
import { JobOpeningType } from "types/careers-types";
import JobsTable from './JobsTable';

interface JobsTabProps {
  searchTerm?: string;
}

const JobsTab = ({ searchTerm = "" }: JobsTabProps) => {
  const [jobs, setJobs] = useState<JobOpeningType[]>([]);

  useEffect(() => {
    fetchJobOpenings()
  }, [])

  const fetchJobOpenings = async () => {
    try {
      const response = await getAllJobOpenings();
      setJobs(response.data);
    } catch(error) {
      console.log(error)
    }
  }

  return (
    <JobsTable jobs={jobs} searchTerm={searchTerm} />
  )
}

export default JobsTab;
